/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCartItemVpsAddResponseFromDiscriminatorValue, serializeWebhusetOrderApiFeaturesCartItemVpsAddRequest, serializeWebhusetOrderApiFeaturesCartItemVpsAddResponse, type WebhusetOrderApiFeaturesCartItemVpsAddRequest, type WebhusetOrderApiFeaturesCartItemVpsAddResponse } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /cart/{cartId}/vps
 */
export interface VpsRequestBuilder extends BaseRequestBuilder<VpsRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCartItemVpsAddResponse>}
     */
     post(body: WebhusetOrderApiFeaturesCartItemVpsAddRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<WebhusetOrderApiFeaturesCartItemVpsAddResponse | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: WebhusetOrderApiFeaturesCartItemVpsAddRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const VpsRequestBuilderUriTemplate = "{+baseurl}/cart/{cartId}/vps";
/**
 * Metadata for all the requests in the request builder.
 */
export const VpsRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: VpsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCartItemVpsAddResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeWebhusetOrderApiFeaturesCartItemVpsAddRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
